import useOffClick from '@flight-workspace/common-client/src/hooks/useOffClick';
import classNames from 'classnames/bind';
import { DateFormat } from 'common/types';
import { SearchType } from 'contexts/searchParams';
import {
  IInternationalContextResult,
  IScheduleDetail,
  ScheduleKeys,
} from 'list/international/types';
import { toDays } from 'list/international/utils';
import { NextRouter } from 'next/router';
import { useState } from 'react';
import styles from './detailSchedule.module.scss';
import { areaCode } from './utils';

import DetailScheduleContent from './detailScheduleContent';

const cx = classNames.bind(styles);

const DetailSchedule = ({
  arrivalHighlight,
  block,
  departureHighlight,
  flightResult,
  isLoading,
  journeyTime,
  router,
  schedule,
  scheduleIndex,
  searchType,
  selectType,
  title,
  removeSchedule = () => {},
}: {
  arrivalHighlight: boolean;
  block: boolean;
  departureHighlight: boolean;
  flightResult: IInternationalContextResult;
  isLoading?: boolean;
  journeyTime: string[];
  router: NextRouter;
  schedule: IScheduleDetail[];
  scheduleIndex: number;
  searchType: SearchType;
  selectType: string;
  title: string;
  removeSchedule: () => void;
}) => {
  const [showDetail, setShowDetail] = useState(false);
  const [isPhotoClick, setIsPhotoClick] = useState(false);
  const ref = useOffClick(() => {
    if (isPhotoClick) return;
    setShowDetail(false);
    setIsPhotoClick(false);
  });

  if (!schedule) {
    return null;
  }

  const [firstSchedule] = schedule;
  const propSdt = firstSchedule?.[ScheduleKeys.startDateTime]
    ? toDays(firstSchedule?.[ScheduleKeys.startDateTime])
    : null;

  return (
    <div
      className={cx('DetailSchedule')}
      role={block ? 'row' : undefined}
      aria-expanded={showDetail}
      data-context="schedule"
    >
      <div className={cx('inner')} ref={ref}>
        <div className={cx('heading')}>
          <b className={cx('name')}>{title}</b>
          <i className={cx('date')}>{propSdt?.format(DateFormat.DotMDd)}</i>
          {(selectType !== 'concurrent' || scheduleIndex === 0) &&
            !isLoading && (
              <button
                type="button"
                className={cx('delete')}
                data-event-nlog="click"
                data-event-area-code={`${areaCode}.delschedule${scheduleIndex + 1}`}
                onClick={removeSchedule}
              />
            )}
        </div>
        {isLoading ? (
          <div
            className={cx('loading_area')}
            aria-label="Loading..."
            aria-busy="true"
          />
        ) : (
          <DetailScheduleContent
            flightResult={flightResult}
            title={title}
            schedule={schedule}
            journeyTime={journeyTime}
            searchType={searchType}
            router={router}
            departureHighlight={departureHighlight}
            arrivalHighlight={arrivalHighlight}
            setIsPhotoClick={setIsPhotoClick}
          />
        )}
      </div>
    </div>
  );
};

export default DetailSchedule;
